import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-about">
            <div className="footer-logo">
              <a href="#home">Nomondoru's Tech Blogs</a>
            </div>
            <p className="footer-description">
              Delivering insightful tech articles, tutorials, and industry analysis for developers and tech enthusiasts.
            </p>
            <div className="social-links">
              <a href="#" className="social-link"><i className="fab fa-twitter"></i></a>
            </div>
          </div>
          
          <div className="footer-nav">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/articles">Articles</Link></li>
            </ul>
          </div>
          
          <div className="footer-categories">
            <h3 className="footer-heading">Categories</h3>
            <ul className="footer-links">
              <li><Link to="/articles?category=javascript">JavaScript</Link></li>
              <li><Link to="/articles?category=python">Python</Link></li>
              <li><Link to="/articles?category=react">React</Link></li>
              <li><Link to="/articles?category=security">Security</Link></li>
              <li><Link to="/articles?category=ai">AI & ML</Link></li>
              <li><Link to="/articles?category=devops">DevOps</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; 2025 Nomondoru's Tech Blogs. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
